<h2 app-landing-page-title i18n="@@firearms.assignment.templates.header">Firearms Assignment Email Templates
</h2>

<app-email-template-parameters [replacementParameters]="replacementParameters">
</app-email-template-parameters>

<mat-card>
  <mat-card-header>
    <mat-card-title i18n="@@firearms.assignment.storage.transfer.policeNotification.header">
      Firearms Assignment - Transfer - Police Notify Email Templates
    </mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <h2 i18n="@@firearms.assignment.storage.policenotification-email-templates.subject">Subject</h2>
    <persistent-simple-text-section-entity section="firearms.assignment.storage.transfer.policeNotification.email.subject"
      [textTransformer]="textTransformer"></persistent-simple-text-section-entity>
    <br />
    <h2 i18n="@@firearms.assignment.storage.policenotification-email-templates.body">Body</h2>
    <persistent-rich-text-section-entity section="firearms.assignment.storage.transfer.policeNotification.email.body"
      [textTransformer]="textTransformer"></persistent-rich-text-section-entity>
  </mat-card-content>
</mat-card>
